export default __webpack_public_path__ + "static/media/icon.3a9530d5.svg";